// Inspired by: https://hackernoon.com/how-to-build-a-stepper-with-compound-components-6a49d90950ba
// @ts-nocheck

import React, { PureComponent } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { colors } from '@lmc/common/constants'
import Swal from 'sweetalert2'
import { ButtonOLD } from '@lmc/ui-kit'

export default class Step extends PureComponent<any, any> {
  checkValid = (nextFunc) => {
    const { isValid, validationText } = this.props
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      iconColor: colors.red,
      showConfirmButton: false,
      timer: 2000,
    })
    if (isValid && !isValid()) {
      return Toast.fire({
        type: 'warning',
        title: validationText,
      })
    }
    nextFunc()
  }

  render() {
    const {
      isActive,
      children,
      displayNext,
      displaySubmit,
      component,
      goToPreviousStep,
      goToNextStep,
      data,
      showNextButton,
      onSubmit,
      submitButtonText,
      stepHeader,
      stepFooter,
      bottom,
      buttonGlyph,
      stepStyles,
	  isLoading,
      ...formProps
    } = this.props

    if (isActive === false) return null

    return (
      <div>
        <div
          style={{
            ...styles.formContainer,
            padding: isDesktop ? '80px 55px 30px' : '80px 0px 30px',
            ...stepStyles,
          }}
        >
          {stepHeader}
          {React.createElement(component, {
            data,
            goToPreviousStep,
            goToNextStep,
            ...formProps,
          })}
          {stepFooter}
        </div>
        {children}
        <div>
          <Next
            isActive={showNextButton && displayNext}
            goToNextStep={() => this.checkValid(goToNextStep)}
          />
          <Submit
            isActive={displaySubmit && onSubmit}
			disabled={isLoading}
            onSubmit={() => this.checkValid(onSubmit)}
            text={submitButtonText}
            glyph={buttonGlyph}
          />
        </div>
      </div>
    )
  }
}

const Next = ({ goToNextStep, isActive }) => {
  if (!isActive) return null
  return (
    <div style={styles.nextButton}>
      <ButtonOLD onClick={goToNextStep} type="primary" style={styles.center}>
        Next Step
      </ButtonOLD>
    </div>
  )
}

const Submit = ({ isActive, onSubmit, text, glyph, disabled = false }) => {
  if (!isActive) {
    return null
  }
  if (glyph) {
    return (
      <div style={styles.nextButton}>
        <ButtonOLD onClick={onSubmit} style={styles.center} type="primary" disabled={disabled} dataTestId={`btn-${text}`}>
          {text || 'Add this To-Do'}
        </ButtonOLD>
      </div>
    )
  }
  return (
    <div style={styles.nextButton}>
      <ButtonOLD onClick={onSubmit} type="primary" disabled={disabled} style={styles.center} dataTestId={`btn-${text}`}>
        {text || 'Add this To-Do'}
      </ButtonOLD>
    </div>
  )
}

const isDesktop = isBrowser || isTablet

const styles = {
  formContainer: {
    paddingBottom: 24,
  },
  nextButton: {
    textAlign: 'center',
    paddingBottom: 120,
    display: 'flex',
    justifyContent: 'center',
  },
  center: {
    justifyContent: 'center',
  },
}
